<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @close-modal="closeModal"
    modal-alignment="top" modal-size="extra-large">
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <div class="row">
        <div class="col-12" v-if="info.fileEvaluation || info.samplingPlanFile">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Equipo Evaluador</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.fileEvaluation">
                <td class="align-middle">
                  Propuesta de designación de equipo evaluador
                </td>
                <td class="align-middle text-center">
                  {{
                      info.fileEvaluation.user
                        ? `${info.fileEvaluation.user.first_name} ${info.fileEvaluation.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.fileEvaluation.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.fileEvaluation.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.samplingPlanFile">
                <td class="align-middle">Plan de muestreo</td>
                <td class="align-middle text-center">
                  {{
                      info.samplingPlanFile.user
                        ? `${info.samplingPlanFile.user.first_name} ${info.samplingPlanFile.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.samplingPlanFile.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.samplingPlanFile.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.fileEvaluationHistorical &&
          info.fileEvaluationHistorical.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historico - Propuesta de designación de equipo evaluador</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.fileEvaluationHistorical" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.samplingPlanFileHistorical &&
          info.samplingPlanFileHistorical.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historico - Plan de muestreo</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.samplingPlanFileHistorical" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--  -->

<div class="col-12" v-if="
          info.last_evaluation_document && info.last_evaluation_document.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>
              Documentación previo a la 
              <span class="title-legend" v-if="info.evalTest.type == 'E'">evaluación</span>
              <span class="title-legend" v-if="info.evalTest.type == 'T'">testificación</span>
               - (Gestor Técnico)
            </h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.last_evaluation_document" :key="i">
                <td class="align-middle">
                  {{ v.filename }}
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.annexed">
                    {{ v.annexed.user.first_name }}
                    {{ v.annexed.user.last_name }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span>{{ v.created_at | dateFormat }}</span>
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.annexed.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


<!--  -->

        <div class="col-12" v-if="info.proforma">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Proforma</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.proforma">
                <td class="align-middle">Proforma</td>
                <td class="align-middle text-center">
                  {{
                      info.proforma.user
                        ? `${info.proforma.user.first_name} ${info.proforma.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.proforma.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.proforma.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.proforms && info.proforms.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historico - Proformas</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.proforms" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{
                      v.proform.user
                        ? `${v.proform.user.first_name} ${v.proform.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.proform.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.proform.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="(info.evalAnnexesFiles && info.evalAnnexesFiles.length > 0) || (info.evaluationTeam && Array.isArray(info.evaluationTeam) && info.evaluationTeam.some(item => item.evaluation_team_external))">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Anexos de honorarios del personal externo</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="
                    align-middle
                    text-center
                  " style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.evalAnnexesFiles" :key="i">
                <td class="align-middle">{{ v.filename }}</td>
                <td class="align-middle text-center">
                  {{
                      v.annexed.user
                        ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.annexed.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.annexed.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
              <!-- <tr v-for="(ext, z) in info.evaluationTeam" :key="z"> -->
              <tr v-for="ext in info.evaluationTeam" :key="ext.id">
                <td class="align-middle" v-if="ext.evaluation_team_external">{{ ext.evaluation_team_external.file_name }}</td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  {{
                      ext.evaluator
                        ? `${ext.evaluator.first_name} ${ext.evaluator.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  {{ ext.evaluation_team_external.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  <button type="submit" class="btn btn-success" @click.prevent="openTabExt(ext,'evaluation_team_external')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.deposits && info.deposits.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>DEPOSITOS</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.deposits" :key="i">
                <td class="align-middle">
                  {{ v.is_agreement == 0 ? "Deposito" : "Convenio" }}
                  {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      v.file ? v.file.user ? `${v.file.user.first_name} ${v.file.user.last_name}`: "": ""
                  }}
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.file">
                    {{ v.file.created_at | dateFormat }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.file">
                    <button type="submit" class="btn btn-success" @click.prevent="openTab(v.file.path)">
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </span>    
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.deposits && info.deposits.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>FACTURAS EMITIDAS</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody v-for="(v, i) in info.deposits" :key="i">
              <tr v-for="(u, j) in v.invoices" :key="j">
                <!-- <div style="width:100%" > -->
                <td class="align-middle">{{ u.filename }}</td>
                <td class="align-middle text-center">
                  <span v-if="u.annexed">
                    {{ `${u.annexed.user.first_name} ${u.annexed.user.last_name}` }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span v-if="u.file">
                    {{ u.file.created_at | dateFormat }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span v-if="u.annexed">
                    <button type="submit" class="btn btn-success" @click.prevent="openTab(u.annexed.path)" v-if="u.annexed">
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </span>
                </td>
                <!-- </div> -->
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.riskMatrix">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Matríz de riesgo</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.riskMatrix">
                <td class="align-middle">Matríz de riesgo</td>
                <td class="align-middle text-center">
                  {{
                      info.riskMatrix.user
                        ? `${info.riskMatrix.user.first_name} ${info.riskMatrix.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.riskMatrix.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.riskMatrix.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.managementSystemFile && info.managementSystemFile.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>
              Documentación del OEC previo a la
              <span class="title-legend" v-if="info.evalTest.type == 'E'">evaluación</span>
              <span class="title-legend" v-if="info.evalTest.type == 'T'">testificación</span>
            </h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.managementSystemFile" :key="i">
                <td class="align-middle">
                  {{ v.filename }}
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.annexed">
                    {{ v.annexed.user.first_name }}
                    {{ v.annexed.user.last_name }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span>{{ v.created_at | dateFormat }}</span>
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.annexed.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.standardEvaluate">
          <legend class="col-12 col-form-label text-primary pt-0 my-3" v-if="info.standardEvaluate.length > 0">
            <h5>Borrador del plan de evaluación</h5>
          </legend>
          <table class="table table-sm table-striped" v-if="info.standardEvaluate.length > 0">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">Punto de la norma a evaluar</td>
                <td class="align-middle text-center">
                  {{
                      info.standardEvaluate[0].user
                        ? `${info.standardEvaluate[0].user.first_name} ${info.standardEvaluate[0].user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.standardEvaluate[0].created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.standardEvaluate[0].path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.evaluationTeam && info.evaluationTeam.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Designaciones Equipo Evaluador</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.evaluationTeam" :key="i">
                <td class="align-middle">
                  {{ v.evaluator.first_name }} {{ v.evaluator.last_name }}
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.evaluation_team_designation">
                    {{ v.evaluation_team_designation.user.first_name }}
                    {{ v.evaluation_team_designation.user.last_name }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.evaluation_team_designation">{{
                      v.evaluation_team_designation.created_at | dateFormat
                  }}</span>
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(v.evaluation_team_designation.path)" v-if="v.evaluation_team_designation">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Evaluaciones de desempeño del equipo evaluador</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  ROL
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.evaluationTeamPerf" :key="i">
                <td class="align-middle">
                  {{ v.evaluator.first_name }} {{ v.evaluator.last_name }}
                </td>
                <td class="align-middle text-center">
                  {{ v.evaluator_type.value }}
                </td>
                <td class="align-middle text-center">
                  {{ v.date_performance | dateFormat }}
                </td>
                <td class="align-middle" v-if="v.evaluation_team_performance">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(v.evaluation_team_performance.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                <td v-else>
                  Aún no se ha cargado el documento
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.otherRecord508">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Ejecución de la testificación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.otherRecord508">
                <td class="align-middle">Otro</td>
                <td class="align-middle text-center">
                  {{
                      info.otherRecord508.user
                        ? `${info.otherRecord508.user.first_name} ${info.otherRecord508.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.otherRecord508.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.otherRecord508.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.testificationReport">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Informe de Testificación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.testificationReport">
                <td class="align-middle">Informe de Testificación</td>
                <td class="align-middle text-center">
                  {{
                      info.testificationReport.user
                        ? `${info.testificationReport.user.first_name} ${info.testificationReport.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.testificationReport.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.testificationReport.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.evaluationTeamHistorical &&
          info.evaluationTeamHistorical.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historial Designaciones Equipo Evaluador</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.evaluationTeamHistorical" :key="i">
                <td class="align-middle">
                  {{ v.evaluator_name }} {{ v.evaluator_name }}
                </td>
                <td class="align-middle text-center">
                  <span v-if="v.user">
                    {{ v.user.first_name }}
                    {{ v.user.last_name }}
                  </span>
                </td>
                <td class="align-middle text-center">
                  <span v-if="v">{{ v.created_at | dateFormat }}</span>
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)" v-if="v">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.otherRecord508">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Ejecución de la testificación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.otherRecord508">
                <td class="align-middle">Otro</td>
                <td class="align-middle text-center">
                  {{
                      info.otherRecord508.user
                        ? `${info.otherRecord508.user.first_name} ${info.otherRecord508.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.otherRecord508.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.otherRecord508.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.attendanceRecordTestification &&
          info.attendanceRecordTestification.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Registro de asistencia participación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.attendanceRecordTestification" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.testificationEvaluationQuestionnaire &&
          info.testificationEvaluationQuestionnaire.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Cuestionario de Testificación Técnicos</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.testificationEvaluationQuestionnaire" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.expertParticipationRecordTestification &&
          info.expertParticipationRecordTestification.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Informe Participación Expertos Técnicos</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.expertParticipationRecordTestification" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-sm-12" v-if="
          info.testification_certification_aditional &&
          info.testification_certification_aditional.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Documentación del OEC previo a la testificación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.testification_certification_aditional" :key="'e' + i">
                <td class="align-middle">
                  {{ v.filename }}
                </td>
                <td class="align-middle text-center">
                  {{ v.annexed.user.full_name }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.annexed.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.testification_509_1 && info.testification_509_1.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Entrega de Informes y documentación de la testificación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.testification_509_1" :key="i">
                <td class="align-middle">{{ v.filename }}</td>
                <td class="align-middle text-center">
                  {{
                      v.annexed.user
                        ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.annexed.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.annexed.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.testification_509_2">
                <td class="align-middle">Anexo Adicional 1</td>
                <td class="align-middle text-center">
                  {{
                      info.testification_509_2.user
                        ? `${info.testification_509_2.user.first_name} ${info.testification_509_2.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.testification_509_2.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.testification_509_2.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <!-- <tr v-if="info.testification_509_3">
                <td class="align-middle">Anexo Adicional 2</td>
                <td class="align-middle text-center">
                  {{
                    info.testification_509_3.user
                      ? `${info.testification_509_3.user.first_name} ${info.testification_509_3.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.testification_509_3.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.testification_509_3.path)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.expertParticipationRecordTestification || info.otherRecord506
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Informe Participación Expertos Técnicos</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.expertParticipationRecordTestification">
                <td class="align-middle">
                  Informe Participación Expertos Técnicos
                </td>
                <td class="align-middle text-center">
                  {{
                      info.expertParticipationRecordTestification.user
                        ? `${info.expertParticipationRecordTestification.user.first_name}
                                    ${info.expertParticipationRecordTestification.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.expertParticipationRecordTestification.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.expertParticipationRecordTestification.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.otherRecord506">
                <td class="align-middle">Otro</td>
                <td class="align-middle text-center">
                  {{
                      info.otherRecord506.user
                        ? `${info.otherRecord506.user.first_name} ${info.otherRecord506.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.otherRecord506.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.otherRecord506.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.reportDocumentaryEvaluation ||
          info.scope401 ||
          info.firstInstanceFinding403 ||
          info.requestAdditionalEvidence ||
          info.secondInstanceFinding403
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Evaluación Documental</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.reportDocumentaryEvaluation">
                <td class="align-middle">Informe de Evaluación Documental</td>
                <td class="align-middle text-center">
                  {{
                      info.reportDocumentaryEvaluation.user
                        ? `${info.reportDocumentaryEvaluation.user.first_name}
                                    ${info.reportDocumentaryEvaluation.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.reportDocumentaryEvaluation.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.reportDocumentaryEvaluation.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.scope401">
                <td class="align-middle">Alcance de Acreditación</td>
                <td class="align-middle text-center">
                  {{
                      info.scope401.user
                        ? `${info.scope401.user.first_name} ${info.scope401.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.scope401.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.scope401.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.firstInstanceFinding403">
                <td class="align-middle">
                  Primera entrega - Informe para el cierre de hallazgos y
                  decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.firstInstanceFinding403.user
                        ? `${info.firstInstanceFinding403.user.first_name} ${info.firstInstanceFinding403.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.firstInstanceFinding403.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.firstInstanceFinding403.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.requestAdditionalEvidence">
                <td class="align-middle">
                  Solicitud de Evidencias Adicionales
                </td>
                <td class="align-middle text-center">
                  {{
                      info.requestAdditionalEvidence.user
                        ? `${info.requestAdditionalEvidence.user.first_name} ${info.requestAdditionalEvidence.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.requestAdditionalEvidence.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.requestAdditionalEvidence.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.secondInstanceFinding403">
                <td class="align-middle">
                  Segunda entrega - Informe para el cierre de hallazgos y
                  decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.secondInstanceFinding403.user
                        ? `${info.secondInstanceFinding403.user.first_name} ${info.secondInstanceFinding403.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.secondInstanceFinding403.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.secondInstanceFinding403.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.evaluationPlanReport ||
          info.remoteInSituAssessmentReport ||
          info.scope_505 ||
          info.otherFindingsFile
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Evaluación InSitu</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.evaluationPlanReport">
                <td class="align-middle">Plan de evaluación</td>
                <td class="align-middle text-center">
                  {{
                      info.evaluationPlanReport.user
                        ? `${info.evaluationPlanReport.user.first_name} ${info.evaluationPlanReport.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.evaluationPlanReport.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.evaluationPlanReport.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <!-- <tr v-if="info.acceptedEvaluationPlan">
                <td class="align-middle">
                  Plan de Evaluación (Aprobado por el OEC)
                </td>
                <td class="align-middle text-center">
                  {{
                    info.acceptedEvaluationPlan.user
                      ? `${info.acceptedEvaluationPlan.user.first_name} ${info.acceptedEvaluationPlan.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.acceptedEvaluationPlan.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.acceptedEvaluationPlan.path)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr> -->

              <tr v-if="info.remoteInSituAssessmentReport">
                <td class="align-middle">
                  Informe de evaluación In-Situ Remota
                </td>
                <td class="align-middle text-center">
                  {{
                      info.remoteInSituAssessmentReport.user
                        ? `${info.remoteInSituAssessmentReport.user.first_name}
                                    ${info.remoteInSituAssessmentReport.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.remoteInSituAssessmentReport.created_at | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.remoteInSituAssessmentReport.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.scope_505">
                <td class="align-middle">Alcance de Acreditación</td>
                <td class="align-middle text-center">
                  {{
                      info.scope_505.user
                        ? `${info.scope_505.user.first_name} ${info.scope_505.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.scope_505.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.scope_505.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.otherFindingsFile">
                <td class="align-middle">Otro</td>
                <td class="align-middle text-center">
                  {{
                      info.otherFindingsFile.user
                        ? `${info.otherFindingsFile.user.first_name} ${info.otherFindingsFile.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.otherFindingsFile.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.otherFindingsFile.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.historicalEvaluationPlanReport &&
          info.historicalEvaluationPlanReport.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historico - Plan de evaluación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.historicalEvaluationPlanReport" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.attendanceRecord && info.attendanceRecord.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Registro de asistencia participación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.attendanceRecord" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.preparationMeeting && info.preparationMeeting.length > 0">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Reunion de preparacion de evaluación</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.preparationMeeting" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.evaluationQuestionnaire &&
          info.evaluationQuestionnaire.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Cuestionario de Evaluación Técnicos</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.evaluationQuestionnaire" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.historicalEvaluationPlanReport &&
          info.historicalEvaluationPlanReport.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Cuestionario de Evaluación Técnicos</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.historicalEvaluationPlanReport" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.expertParticipationRecord &&
          info.expertParticipationRecord.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Informe Participación Expertos Técnicos</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.expertParticipationRecord" :key="i">
                <td class="align-middle">Documento {{ i + 1 }}</td>
                <td class="align-middle text-center">
                  {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.riskMatrix505">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Matriz de Análisis de riesgos y programa</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.riskMatrix505">
                <td class="align-middle">
                  Matriz de Análisis de riesgos y programa
                </td>
                <td class="align-middle text-center">
                  {{
                      info.riskMatrix505.user
                        ? `${info.riskMatrix505.user.first_name} ${info.riskMatrix505.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.riskMatrix505.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.riskMatrix505.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="info.other_file_505 && info.other_file_505.length > 0">
          <legend>
            <p class="text-primary">
              <small>(Evaluación InSitu / Remota) Otros archivos cargados</small>
            </p>
          </legend>
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th scope="col" class="align-middle text-center" style="width: 25%">
                      USUARIO
                    </th>
                    <th scope="col" class="text-center" style="width: 15%">
                      FECHA DE CREACIÓN
                    </th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, key) in info.other_file_505" :key="key">
                    <td class="align-middle">
                      {{ value.filename }}
                    </td>
                    <td class="align-middle text-center">
                      {{
                          value.annexed.user
                            ? `${value.annexed.user.first_name} ${value.annexed.user.last_name}`
                            : ""
                      }}
                    </td>
                    <td class="align-middle text-center">
                      {{ value.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <button type="submit" class="btn btn-success" @click.prevent="openTab(value.annexed.path, key)">
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12" v-if="
          info.firstInstanceFinding601 ||
          info.requestAdditionalEvidence603 ||
          info.secondInstanceFinding601 ||
          info.thirdInstanceFinding601 ||
          // info.suspendedDecisionReport ||
          info.scope605
          // || info.technicalFileAnalysisReport
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>No Conformidades</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.firstInstanceFinding601">
                <td class="align-middle">
                  Primera entrega - Informe para el cierre de hallazgos y
                  decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.firstInstanceFinding601.user
                        ? `${info.firstInstanceFinding601.user.first_name} ${info.firstInstanceFinding601.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.firstInstanceFinding601.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.firstInstanceFinding601.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
              <tr v-if="info.historicalRequestAdditionalEvidence603">
                <td class="align-middle">
                  Solicitud de Evidencias Adicionales
                </td>
                <td class="align-middle text-center">
                  {{
                      info.historicalRequestAdditionalEvidence603.user
                        ? `${info.historicalRequestAdditionalEvidence603.user.first_name}
                                    ${info.historicalRequestAdditionalEvidence603.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.historicalRequestAdditionalEvidence603.created_at | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.historicalRequestAdditionalEvidence603.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.requestAdditionalEvidence603">
                <td class="align-middle">
                  Solicitud de Evidencias Adicionales
                </td>
                <td class="align-middle text-center">
                  {{
                      info.requestAdditionalEvidence603.user
                        ? `${info.requestAdditionalEvidence603.user.first_name}
                                    ${info.requestAdditionalEvidence603.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.requestAdditionalEvidence603.updated_at | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.requestAdditionalEvidence603.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.historicalRequestAdditionalEvidence603_2">
                <td class="align-middle">
                  Solicitud de Evidencias Adicionales
                </td>
                <td class="align-middle text-center">
                  {{
                      info.historicalRequestAdditionalEvidence603_2.user
                        ? `${info.historicalRequestAdditionalEvidence603_2.user.first_name}
                                    ${info.historicalRequestAdditionalEvidence603_2.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.historicalRequestAdditionalEvidence603_2.created_at | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.historicalRequestAdditionalEvidence603_2.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.secondInstanceFinding601">
                <td class="align-middle">Primera evidencia adicional</td>
                <td class="align-middle text-center">
                  {{
                      info.secondInstanceFinding601.user
                        ? `${info.secondInstanceFinding601.user.first_name} ${info.secondInstanceFinding601.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.secondInstanceFinding601.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.secondInstanceFinding601.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.thirdInstanceFinding601">
                <td class="align-middle">Segunda evidencia adicional</td>
                <td class="align-middle text-center">
                  {{
                      info.thirdInstanceFinding601.user
                        ? `${info.thirdInstanceFinding601.user.first_name} ${info.thirdInstanceFinding601.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.thirdInstanceFinding601.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.thirdInstanceFinding601.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <!-- <tr v-if="info.suspendedDecisionReport">
                <td class="align-middle">
                  Informe de la comisión de acreditación
                </td>
                <td class="align-middle text-center">
                  {{
                    info.suspendedDecisionReport.user
                      ? `${info.suspendedDecisionReport.user.first_name} ${info.suspendedDecisionReport.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.suspendedDecisionReport.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.suspendedDecisionReport.path)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr> -->

              <tr v-if="info.scope605">
                <td class="align-middle">Alcance de Acreditación</td>
                <td class="align-middle text-center">
                  {{
                      info.scope605.user
                        ? `${info.scope605.user.first_name} ${info.scope605.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.scope605.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(info.scope605.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <!-- <tr v-if="info.technicalFileAnalysisReport">
                <td class="align-middle">
                  Informe Técnico de Análisis de Expediente y de Toma de
                  Decisión
                </td>
                <td class="align-middle text-center">
                  {{
                    info.technicalFileAnalysisReport.user
                      ? `${info.technicalFileAnalysisReport.user.first_name} ${info.technicalFileAnalysisReport.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.technicalFileAnalysisReport.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(info.technicalFileAnalysisReport.path)
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>
        <!-- elaboracion del plan de accion -->
        <div class="col-12" v-if="
          info.action_plan
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Plan de acción</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.action_plan">
                <td class="align-middle">
                  Plan de acción
                </td>
                <td class="align-middle text-center">
                  {{
                      info.action_plan.user
                        ? `${info.action_plan.user.first_name} ${info.action_plan.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.action_plan.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.action_plan.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Historico de plan de accion -->

        <div class="col-12" v-if="
          info.historical512 && info.historical512.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historico de plan de acción</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(historical, i) in info.historical512" :key="i">
                <td class="align-middle">
                  Plan de acción - {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      historical.user
                        ? `${historical.user.first_name} ${historical.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ historical.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(historical.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Correciones de plan de accion -->

        <div class="col-12" v-if="
          info.observation_plan_action
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Correciones del plan de acción</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  Correciones
                </td>
                <td class="align-middle text-center">
                  {{
                      info.observation_plan_action.user
                        ? `${info.observation_plan_action.user.first_name} ${info.observation_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.observation_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.observation_plan_action.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- historico de las correciones de plan de accion -->
        <div class="col-12" v-if="
          info.historical513 && info.historical513.length > 0
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Historico de las correciones de plan de acción</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(historical, i) in info.historical513" :key="i">
                <td class="align-middle">
                  Corrección del plan de acción - {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      historical.user
                        ? `${historical.user.first_name} ${historical.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ historical.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(historical.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- nforme para el cierre de No Conformidades -->
        <div class="col-12" v-if="
          info.report_plan_action
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Informe para el cierre de No Conformidades de OEC y para la Decisión</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  Informe para el cierre de No Conformidades de OEC y para la Decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.report_plan_action.user
                        ? `${info.report_plan_action.user.first_name} ${info.report_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ info.report_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.report_plan_action.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.support_management_non_conformities_601_1 &&
          info.support_management_non_conformities_601_1.length > 0
        ">
          <legend class="text-primary">
            Respaldo informe para el cierre de hallazgos y decisión primera
            entrega
          </legend>
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.support_management_non_conformities_601_1" :key="i">
                <td class="align-middle"><small class="text-primary">{{
                    v.path.split(
                      "/"
                    )[
                    v.path.split(
                      "/"
                    ).length - 1
                    ]
                }}</small></td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.support_management_non_conformities_601_2 &&
          info.support_management_non_conformities_601_2.length > 0
        ">
          <legend class="text-primary">
            Respaldo informe para el cierre de hallazgos y decisión primera
            entrega de evidencia adicional
          </legend>
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.support_management_non_conformities_601_2" :key="i">
                <td class="align-middle"><small class="text-primary">{{
                    v.path.split(
                      "/"
                    )[
                    v.path.split(
                      "/"
                    ).length - 1
                    ]
                }}</small></td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.support_management_non_conformities_601_3 &&
          info.support_management_non_conformities_601_3.length > 0
        ">
          <legend class="text-primary">
            Respaldo informe para el cierre de hallazgos y decisión segunda
            entrega de evidencia adicional
          </legend>
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in info.support_management_non_conformities_601_3" :key="i">
                <td class="align-middle"><small class="text-primary">{{
                    v.path.split(
                      "/"
                    )[
                    v.path.split(
                      "/"
                    ).length - 1
                    ]
                }}</small></td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="(info.extensionTime601All && info.extensionTime601All.length > 0) || (info.testification_509_2 && info.testification_509_2.length > 0)">
          <legend class="text-primary">
            Documentación de extensión de tiempo OEC
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              
              <tr v-for="(v, i) in info.extensionTime601All" :key="i">
                <td class="align-middle">Extensión de tiempo evaluación</td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
              <tr v-for="(v, i) in info.testification_509_2" :key="i">
                <td class="align-middle">Extensión de tiempo testificación</td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="(info.extensionTime603All && info.extensionTime603All.length > 0)">
          <legend class="text-primary">
            Documentación de extensión de tiempo lider
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              
              <tr v-for="(v, i) in info.extensionTime603All" :key="i">
                <td class="align-middle">Extensión de tiempo evaluación</td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          info.findings_closing_report_603_first ||
          info.findings_closing_report_603_second ||
          info.findings_closing_report_603_third
        ">
          <legend class="col-12 col-form-label text-primary pt-0 my-3">
            <h5>Informes de cierres de hallazgos (Evaluador)</h5>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.findings_closing_report_603_first">
                <td class="align-middle">
                  Primera entrega - Informe para el cierre de hallazgos y
                  decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.findings_closing_report_603_first.user
                        ? `${info.findings_closing_report_603_first.user.first_name}
                                    ${info.findings_closing_report_603_first.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.findings_closing_report_603_first.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.findings_closing_report_603_first.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.findings_closing_report_603_second">
                <td class="align-middle">
                  Segunda entrega - Informe para el cierre de hallazgos y
                  decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.findings_closing_report_603_second.user
                        ? `${info.findings_closing_report_603_second.user.first_name}
                                    ${info.findings_closing_report_603_second.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.findings_closing_report_603_second.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="
                    openTab(info.findings_closing_report_603_second.path)
                  ">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.findings_closing_report_603_third">
                <td class="align-middle">
                  Tercera entrega - Informe para el cierre de hallazgos y
                  decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      info.findings_closing_report_603_third.user
                        ? `${info.findings_closing_report_603_third.user.first_name}
                                    ${info.findings_closing_report_603_third.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                      info.findings_closing_report_603_third.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(info.findings_closing_report_603_third.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  mixins: [ModalMixin],
  props: {
    evalTestId: Number,
  },
  data() {
    return {
      preloader: false,
      modalId: "audit-eval-test-modal",
      modalTitle: "",
      info: {
        evaluationTeam: []
      },
    };
  },
  created() {
    this.getData();
  },
  filters: {
    dateFormat: function (value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
  },
  methods: {
    getData() {
      this.preloader = true;
      let url = `/audit/accreditation/${this.$store.state.common.accAppId}/evalTest/${this.evalTestId}/log`;
      axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.info = response.data;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    openTab(path) {
      var info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.evalTestId;
      info['path'] = String(path);
      this.$store.dispatch("registerFileLog", info);
      window.open(path, "_blank").focus();
    },
    openTabExt(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>
<style>
.title-legend {
  font-size: 1em;
}
</style>
